import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = {
  class: "btn btn-success mr-1",
  style: {"padding":"0.7em 2em"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-12" }
const _hoisted_7 = { class: "table table-bordered table-hover" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_13 = { class: "dropdown-item" }
const _hoisted_14 = { class: "dropdown-item" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

import { computed, onMounted, ref, type Ref, watch } from 'vue'
    import { useRoute } from 'vue-router'

    import moment from 'moment'

    import { generateName } from '@common/Common'
    import { guid } from '@common/Guid'
    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'

    import { useScenariosPageQueryV1 } from '@Quest/CorporateScenarios/queries-vue-composables'

    import {
        useCloneCorporateScenarioCommandV1,
        useCreateCorporateScenarioCommandV1,
        useDeleteCorporateScenarioCommandV1,
        useUpdateCorporateScenarioCommandV1
    } from '@Quest/CorporateScenarios/commands-vue-composables'

    import type {
        CorporateScenarioReadModel,
        ScenariosPageReadModel
    } from '@Quest/CorporateScenarios/readmodels'

    // ======================
    // Route params
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ScenariosPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    // ======================
    // Query
    // ======================

    const {
        runScenariosPageQueryV1,
        modelScenariosPageQueryV1
    } = useScenariosPageQueryV1(workspaceId, strategyId)

    const rm = modelScenariosPageQueryV1 as Ref<ScenariosPageReadModel | null>

    const scenarioIdToDelete = ref<string | null>(null)

    // ======================
    // Commands
    // ======================

    const {
        invokeCloneCorporateScenarioCommandV1,
        succeedCloneCorporateScenarioCommandV1
    } = useCloneCorporateScenarioCommandV1(workspaceId, strategyId)

    const {
        invokeCreateCorporateScenarioCommandV1,
        succeedCreateCorporateScenarioCommandV1
    } = useCreateCorporateScenarioCommandV1(workspaceId, strategyId)

    const {
        invokeUpdateCorporateScenarioCommandV1,
        succeedUpdateCorporateScenarioCommandV1
    } = useUpdateCorporateScenarioCommandV1(workspaceId, strategyId)

    const {
        invokeDeleteCorporateScenarioCommandV1,
        succeedDeleteCorporateScenarioCommandV1
    } = useDeleteCorporateScenarioCommandV1(workspaceId, strategyId, scenarioIdToDelete)



    // ======================
    // Formatting
    // ======================

    function formatDate(date: Date | null)
    {
        if (date == null) return null
        return moment(date).format('MMM D, YYYY')
    }

    function formatTime(date: Date | null)
    {
        if (date == null) return null
        return moment(date).format('LT')
    }

    // ======================
    // Handlers
    // ======================

    function handleCloneCorporateScenarioCommand(s: CorporateScenarioReadModel)
    {
        invokeCloneCorporateScenarioCommandV1({
            Id: guid(),
            SourceId: s.Id,
            CloneName: generateName(s.Name)
        })
    }

    function handleDeleteCorporateScenarioCommand(scenarioId: string)
    {
        if (confirm('Are you sure?') === true)
        {
            scenarioIdToDelete.value = scenarioId
            invokeDeleteCorporateScenarioCommandV1()
        }
    }

    // ======================
    // Command Success Watchers
    // ======================

    watch(succeedCreateCorporateScenarioCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runScenariosPageQueryV1()
        }
    })

    watch(succeedUpdateCorporateScenarioCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runScenariosPageQueryV1()
        }
    })

    watch(succeedCloneCorporateScenarioCommandV1, (current, previous) =>
    {
        if (current && !previous)
        {
            runScenariosPageQueryV1()
        }
    })

    watch(succeedDeleteCorporateScenarioCommandV1, (current, previous) =>
    {
        if (current && !previous && rm.value && scenarioIdToDelete.value)
        {
            rm.value.Scenarios = rm.value.Scenarios.filter(a => a.Id !== scenarioIdToDelete.value)
            scenarioIdToDelete.value = null
        }
    })

    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = 'Enterprise Plans'
        runScenariosPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Enterprise plans")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Create plan", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/enterprise-plan/settings/${workspaceId.value}/${strategyId.value}`]
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("a", {
                class: "btn btn-lg btn-outline-secondary",
                href: "https://www.transparentchoice.com/client-hub/user-guide/scenarios",
                title: "Documentation",
                target: "_blank"
              }, [
                _createElementVNode("i", {
                  class: "fa fa-info",
                  "aria-hidden": "true"
                })
              ], -1 /* CACHED */))
            ])
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("table", _hoisted_7, [
                  _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "text-center",
                        style: {"width":"120px"}
                      }, "Created"),
                      _createElementVNode("th", null, "Plan"),
                      _createElementVNode("th", {
                        class: "text-center",
                        style: {"width":"240px"}
                      }, "Planning horizon"),
                      _createElementVNode("th", {
                        class: "text-center",
                        style: {"width":"120px"}
                      }, "Portfolios"),
                      _createElementVNode("th", { style: {"width":"120px"} })
                    ])
                  ], -1 /* CACHED */)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Scenarios, (s) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: s.Id
                      }, [
                        _createElementVNode("td", _hoisted_8, [
                          _createTextVNode(_toDisplayString(formatDate(s.CreatedDate)), 1 /* TEXT */),
                          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _createElementVNode("small", null, _toDisplayString(formatTime(s.CreatedDate)), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives((_openBlock(), _createElementBlock("a", null, [
                            _createTextVNode(_toDisplayString(s.Name), 1 /* TEXT */)
                          ])), [
                            [_directive_sanitizedHref, `/#/enterprise-plan/portfolios/${workspaceId.value}/${strategyId.value}/${s.Id}`]
                          ]),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _createElementVNode("small", null, _toDisplayString(s.Description), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(formatDate(s.PlanningStartDate)) + " - " + _toDisplayString(formatDate(s.PlanningEndDate)), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(s.Portfolios), 1 /* TEXT */),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[8] || (_cache[8] = _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-secondary dropdown-toggle",
                              "data-toggle": "dropdown"
                            }, " Actions ", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, [...(_cache[5] || (_cache[5] = [
                                _createTextVNode("View", -1 /* CACHED */)
                              ]))])), [
                                [_directive_sanitizedHref, `/#/enterprise-plan/portfolios/${workspaceId.value}/${strategyId.value}/${s.Id}`]
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("Settings", -1 /* CACHED */)
                              ]))])), [
                                [_directive_sanitizedHref, `/#/enterprise-plan/settings/${workspaceId.value}/${strategyId.value}/${s.Id}`]
                              ]),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (handleCloneCorporateScenarioCommand(s))
                              }, "Clone", 8 /* PROPS */, _hoisted_15),
                              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (handleDeleteCorporateScenarioCommand(s.Id))
                              }, "Delete", 8 /* PROPS */, _hoisted_16)
                            ])
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})